// Auth readiness coordination: prevents early bursts of 401s by letting consumers wait
// for the initial auth/session resolution. Provides a bounded wait with timeout.

let ready = false;
let aborted = false;
let resolveFn: (() => void) | null = null;

const readyPromise = new Promise<void>((resolve) => { resolveFn = resolve; });
const MAX_WAIT_MS = 6000;
const start = Date.now();

export const isAuthReady = () => ready || aborted;

export const markAuthReady = () => {
	if (!ready) {
		ready = true;
		resolveFn && resolveFn();
	}
};

export const abortAuthWait = () => {
	if (!ready && !aborted) {
		aborted = true;
		resolveFn && resolveFn();
	}
};

export const waitForAuthReady = async (timeoutMs = MAX_WAIT_MS) => {
	if (isAuthReady()) return;
	const elapsed = Date.now() - start;
	const remaining = timeoutMs - elapsed;
	if (remaining <= 0) return;
	let timeoutHandle: number | undefined;
	await Promise.race([
		readyPromise,
		new Promise<void>((res) => {
			timeoutHandle = window.setTimeout(() => {
				abortAuthWait();
				res();
			}, remaining);
		}),
	]);
	if (timeoutHandle) clearTimeout(timeoutHandle);
};

// For debugging (dev only): attach to window
